export default "__VITE_ASSET__CAuW7CMw__"